const getEnv = (name: string, defaultValue?: string) =>
  global?.__ENV__?.[name] ?? process.env[name] ?? defaultValue;

export default getEnv;
